// removed by extract-text-webpack-plugin
module.exports = {"icon":"_2Kp3q","linkActive":"_3IBLk","bubble":"_3rQFJ","collection":"_5BNN1"};